const MOSCOW_TIME_ZONE = "Europe/Moscow";

/**
 * Converts a server reset instant (Moscow-based on backend) to local midnight
 * on the same Moscow calendar date — matches Android device timezone behavior.
 */
export function toLocalResetTarget(serverResetDate: Date): Date {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: MOSCOW_TIME_ZONE,
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).formatToParts(serverResetDate);

  const year = Number(parts.find((p) => p.type === "year")!.value);
  const month = Number(parts.find((p) => p.type === "month")!.value);
  const day = Number(parts.find((p) => p.type === "day")!.value);

  return new Date(year, month - 1, day, 0, 0, 0, 0);
}

export function getMillisecondsUntilReset(
  serverResetDate: Date | null,
  now: Date = new Date()
): number {
  if (!serverResetDate || isNaN(serverResetDate.getTime())) {
    return 0;
  }

  return toLocalResetTarget(serverResetDate).getTime() - now.getTime();
}

export function isResetPassed(
  serverResetDate: Date | null,
  now: Date = new Date()
): boolean {
  return getMillisecondsUntilReset(serverResetDate, now) <= 0;
}
